import Thread from './Thread';
import KeldaError from '../kelda/KeldaError';
var ThreadPool = /** @class */ (function () {
    function ThreadPool(threadPoolDepth) {
        this.queue = [];
        ThreadPool.validate(threadPoolDepth);
        this.threads = this.populateThreads(threadPoolDepth);
        this.doFromQueue = this.doFromQueue.bind(this);
    }
    ThreadPool.validate = function (threadPoolDepth) {
        // TODO: should throw if desired depth is greater than navigator.hardwareConcurrency?
        if (threadPoolDepth <= 0)
            throw new KeldaError('threadPoolDepth must be greater than 0');
    };
    ThreadPool.prototype.schedule = function (job) {
        var _this = this;
        var thread = this.getThread();
        if (thread) {
            return thread.do(job).finally(this.doFromQueue);
        }
        return new Promise(function (resolve, reject) {
            var toEnqueue = [job, resolve, reject];
            _this.queue.push(toEnqueue);
        });
    };
    ThreadPool.prototype.doFromQueue = function () {
        var thread = this.getThread();
        if (thread && this.queue.length) {
            var enqueued = this.queue.shift();
            var _a = enqueued, job = _a[0], resolve = _a[1], reject = _a[2];
            thread
                .do(job)
                .then(resolve)
                .catch(reject) // TODO: should re-enqueue/retry on failure? How many times?
                .finally(this.doFromQueue);
        }
    };
    ThreadPool.prototype.populateThreads = function (threadPoolDepth) {
        return Array(threadPoolDepth)
            .fill(null)
            .map(function () { return new Thread(); });
    };
    ThreadPool.prototype.getThread = function () {
        return this.threads.find(function (thread) { return thread.isIdle; });
    };
    return ThreadPool;
}());
export default ThreadPool;
